export const activities = {
  COUNTDOWN: 'countdown',
  INTRODUCTION: 'introduction',
  BREAK: 'break',
  COMPETITION: 'competition',
  VICTORY_CEREMONY: 'victory-ceremony',
};



// WEBPACK FOOTER //
// ./src/venue/constants.js